import { ApiGateWay } from './../../ApiGateWay/ApiGateWay';
import { Config } from './../../config/config';
import Cookie from 'js-cookie';

const config = JSON.parse(Config);

export const SAFTEY_GLOBAL = async (url, userId, month, year, type) => {
  const fetchedData = await ApiGateWay.Post(config['api'] + url, {
    userId: userId,
    month: month,
    year: year,
    type: type,
  })
    .then((response) => response.json())
    .then((response) => {
      if (
        response.errorMessage === 'Token Expired' ||
        response.errorMessage === 'Invalid Token:::JWT expired' ||
        response.errorMessage ===
          'Your session has expired. Please login again.'
      ) {
        Cookie.remove('currentUser');
        Cookie.remove('stores');
        Cookie.remove('storesAll');
        Cookie.remove('warehouses');

        localStorage.clear();
        sessionStorage.clear();
        alert('Your session has expired. Please login again.');
        return (window.location = '/');
      }
      let body = [];
      let colorCodes = [];
      let proxyjson = [];
      let stores = [];
      let storeID = [];
      response.safetyRegisterGlobalDashboard
        .sort((a, b) => (a.storeName > b.storeName ? 1 : -1))
        .map((name, val) => {
          storeID.push(name.storeId);
          stores.push(name.storeName);
          name.compliance === '100%' && name.contracts === '100%'
            ? colorCodes.push([0, 1, 1])
            : name.compliance != '100%' && name.contracts === '100%'
            ? colorCodes.push([0, 2, 1])
            : name.compliance === '100%' && name.contracts != '100%'
            ? colorCodes.push([0, 1, 2])
            : name.compliance != '100%' && name.contracts != '100%'
            ? colorCodes.push([0, 2, 2])
            : colorCodes.push([0, 0, 0]);

          body.push([name.objective, name.compliance, name.contracts]);
        });
      return (proxyjson = {
        type: 'Safety',
        thead: ['Store Name', 'Objective', 'Compliance', 'Contracts'],
        tbody: body,
        columns: ['Store Name', 'Objective', 'Compliance', 'Contracts'],
        colorCodes: colorCodes,
        storeId: storeID,
        stores: stores,
        popUpDataGrid: body,
        popUpDataGridHeaders: [
          'SlNo',
          'Document Type',
          'Uploaded Date',
          'Expiry Date',
          'Uploaded By',
          'Status',
          'View Document',
        ],
      });
    });
  return fetchedData;
};

export const SAFTEY_STORE = async (url, year, storeId) => {
  const fetchedData = await ApiGateWay.Get(
    config['api'] + url + '?year=' + year + '&storeId=' + storeId
  )
    .then((response) => response.json())
    .then((response) => {
      if (
        response.errorMessage === 'Token Expired' ||
        response.errorMessage === 'Invalid Token:::JWT expired' ||
        response.errorMessage ===
          'Your session has expired. Please login again.'
      ) {
        Cookie.remove('currentUser');
        Cookie.remove('stores');
        Cookie.remove('storesAll');
        Cookie.remove('warehouses');

        localStorage.clear();
        sessionStorage.clear();
        alert('Your session has expired. Please login again.');
        return (window.location = '/');
      }
      let body = [];
      let colorCodes = [];
      let proxyjson = [];
      let stores = [];
      response.storewiseSafetyRegisterGlobalDashboard.map((name, val) => {
        stores.push(name.month);
        name.compliance === '100%' && name.contracts === '100%'
          ? colorCodes.push([0, 1, 1])
          : name.compliance !== '100%' && name.contracts === '100%'
          ? colorCodes.push([0, 2, 1])
          : name.compliance === '100%' && name.contracts !== '100%'
          ? colorCodes.push([0, 1, 2])
          : name.compliance !== '100%' && name.contracts !== '100%'
          ? colorCodes.push([0, 2, 2])
          : colorCodes.push([0, 0, 0]);
        body.push([name.objective, name.compliance, name.contracts]);
      });
      return (proxyjson = {
        type: 'SafetyStore',
        thead: ['Month', 'Objective', 'Compliance', 'Contracts'],
        tbody: body,
        popUpDataGridHeaders: [
          'SlNo',
          'Document Type',
          'Uploaded Date',
          'Expiry Date',
          'Uploaded By',
          'Status',
          'View Document',
        ],
        columns: ['Month', 'Objective', 'Compliance', 'Contracts'],
        colorCodes: colorCodes,
        stores: stores,
      });
    });
  return fetchedData;
};
